import {
	Box,
	Stack,
	TextField,
	DoubleField,
	IntegerField,
	Select,
	Tooltip,
	IconWarningRegular,
	skinVars,
	GridItem,
	Grid,
	useScreenSize,
} from "@telefonica/mistica";
import { Link } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { LINK_CEP_CORREIOS, states } from "../../../constants";
import { strings } from "../../../localization";

interface IProps {
	additionalInfo: string;
	address: string;
	districtName: string;
	countrySubDivision: string;
	number: string;
	postalCode: string;
	townName: string;
	isPostalCodeError?: boolean;
	postalCodeErrorText?: string;
	isAddressError?: boolean;
	addressErrorText?: string;
	isAdditionalInfoDisabled?: boolean;
	isAddressDisabled?: boolean;
	isDistrictNameDisabled?: boolean;
	isCountrySubDivisionDisabled?: boolean;
	isNumberDisabled?: boolean;
	isPostalCodeDisabled?: boolean;
	isTownNameDisabled?: boolean;
	onChangeAdditionalInfo(t: string): void;
	onChangeAddress(t: string): void;
	onChangeDistrictName(t: string): void;
	onChangeCountrySubDivision(t: string): void;
	onChangeNumber(t: string): void;
	onChangePostalCode(t: string): void;
	onChangeTownName(t: string): void;
}
export const AddressInputGroup: React.FC<IProps> = observer((props) => {
	const { isDesktopOrBigger } = useScreenSize();
	const { addressInputGroup } = strings.components;
	const {
		additionalInfo,
		address,
		districtName,
		countrySubDivision,
		number,
		postalCode,
		townName,
		isPostalCodeError,
		postalCodeErrorText = addressInputGroup.postalCodeErrorText,
		isAdditionalInfoDisabled,
		isAddressDisabled,
		isDistrictNameDisabled,
		isCountrySubDivisionDisabled,
		isNumberDisabled,
		isPostalCodeDisabled,
		isTownNameDisabled,
		onChangeAdditionalInfo,
		onChangeAddress,
		onChangeDistrictName,
		onChangeCountrySubDivision,
		onChangeNumber,
		onChangePostalCode,
		onChangeTownName,
	} = props;

	return (
		<Box paddingY={32}>
			<Stack space={16}>
				<TextField
					label={addressInputGroup.postalCode}
					name="postalCode"
					value={postalCode}
					error={isPostalCodeError}
					helperText={isPostalCodeError ? postalCodeErrorText : undefined}
					disabled={isPostalCodeDisabled}
					onChangeValue={onChangePostalCode}
					data-cs-mask
					endIcon={
						<Tooltip
							target={<IconWarningRegular size={26} color={skinVars.colors.textSecondary} />}
							description={addressInputGroup.tooltip}
							position="top"
						/>
					}
				/>
				<Grid columns={{ maxSize: isDesktopOrBigger ? 320 : 380 }} justifyItems="end" rows={1}>
					<GridItem>
						<Link
							href={LINK_CEP_CORREIOS}
							target="_blank"
							rel="noopener noreferrer"
							color={skinVars.colors.textLink}
							fontSize="14px"
						>
							{addressInputGroup.linkText}
						</Link>
					</GridItem>
				</Grid>
				<TextField
					label={addressInputGroup.address}
					name="address"
					value={address}
					error={props.isAddressError}
					helperText={props.isAddressError ? props.addressErrorText : undefined}
					disabled={isAddressDisabled}
					onChangeValue={onChangeAddress}
					data-cs-mask
				/>
				<DoubleField layout="50/50">
					<IntegerField
						label={addressInputGroup.number}
						name="number"
						value={number}
						disabled={isNumberDisabled}
						onChangeValue={onChangeNumber}
						data-cs-mask
					/>
					<TextField
						label={addressInputGroup.complement}
						name="complement"
						helperText="Deixe em branco se não tiver"
						value={additionalInfo}
						disabled={isAdditionalInfoDisabled}
						onChangeValue={onChangeAdditionalInfo}
					/>
				</DoubleField>
				<TextField
					label={addressInputGroup.neighborhood}
					name="neighborhood"
					value={districtName}
					disabled={isDistrictNameDisabled}
					onChangeValue={onChangeDistrictName}
					data-cs-mask
				/>
				<DoubleField layout="50/50">
					<Select
						name="state"
						label={addressInputGroup.state}
						options={states}
						value={countrySubDivision}
						disabled={isCountrySubDivisionDisabled}
						onChangeValue={onChangeCountrySubDivision}
					/>
					<TextField
						label={addressInputGroup.city}
						name="city"
						value={townName}
						disabled={isTownNameDisabled}
						onChangeValue={onChangeTownName}
						data-cs-mask
					/>
				</DoubleField>
			</Stack>
		</Box>
	);
});
